import { useDispatch } from "react-redux"
import { Box, ButtonBase, Stack, Typography } from "@mui/material"
import { ROTULO_CONSUMO, useGetLojaAtualQuery, type ConsumoTotem } from "@/api"
import { irVista } from "./navegacao"

const ORDEM_NA_TELA: ConsumoTotem[] = ['LEVAR', 'LOCAL']

const ILUSTRACAO: Record<ConsumoTotem, string> = {
    LEVAR: '/images/totem-pedidos/take-out.png',
    LOCAL: '/images/totem-pedidos/dine-in.png',
}

const ALTURA_ILUSTRACAO: Record<ConsumoTotem, { xs: number; md: number }> = {
    LEVAR: { xs: 106, md: 170 },
    LOCAL: { xs: 100, md: 160 },
}

export default function Consumo(): JSX.Element {
    const dispatch = useDispatch()
    const { data: loja } = useGetLojaAtualQuery()

    return (
        <Stack
            spacing={4}
            sx={{
                alignContent: 'center',
                height: '100dvh',
                justifyContent: 'center',
                width: '100%',
                maxWidth: 1100,
                mx: 'auto',
                px: { xs: 3, md: 6 },
            }}
        >
            <Stack sx={{ alignItems: 'center' }}>
                {loja?.configuracao.urlLogo ? (
                    <Box
                        component="img"
                        src={loja.configuracao.urlLogo}
                        alt={loja.configuracao.nome}
                        sx={{ maxHeight: { xs: 130, md: 140 }, maxWidth: '70%', objectFit: 'contain' }}
                    />
                ) : (
                    <Typography variant="h3" sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                        {loja?.configuracao.nome}
                    </Typography>
                )}

            </Stack>

            <Typography variant="h3" sx={{ fontWeight: 'bold', textAlign: 'center', mt: 1 }}>
                Como você deseja consumir?
            </Typography>

            <Stack spacing={2}>
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={{ xs: 3, md: 4 }}
                    sx={{ flex: 1, alignItems: 'stretch', justifyContent: 'center' }}
                >
                    {ORDEM_NA_TELA.map((consumo) => (
                        <CartaoConsumo
                            key={consumo}
                            consumo={consumo}
                            aoEscolher={() => irVista(dispatch, { currentView: 'VIEW_CATALOGO', consumo })}
                        />
                    ))}
                </Stack>
            </Stack>
        </Stack>
    )
}

function CartaoConsumo({ consumo, aoEscolher, }: { consumo: ConsumoTotem; aoEscolher: () => void; }): JSX.Element {
    return (
        <ButtonBase
            onClick={aoEscolher}
            sx={(t) => ({
                flex: 1,
                aspectRatio: '3 / 4',
                maxHeight: { xs: 300, md: 420 },
                borderRadius: 6,
                p: { xs: 3, md: 4 },
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
                color: 'text.primary',
                transition: 'transform .15s ease-in-out',
                '&:active': { transform: 'scale(0.98)' },
            })}
        >
            <Stack
                spacing={{ xs: 2, md: 3 }}
                sx={{ alignItems: 'center', justifyContent: 'space-evenly', width: '100%', height: '100%' }}
            >
                <Stack sx={{ width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                    <Box
                        component="img"
                        src={ILUSTRACAO[consumo]}
                        alt=""
                        sx={{
                            height: ALTURA_ILUSTRACAO[consumo],
                            maxWidth: '100%',
                            objectFit: 'contain',
                        }}
                    />

                    <Typography variant="h4" sx={{ fontWeight: 'bold', textAlign: 'center', width: '100%', whiteSpace: 'nowrap', overflow: 'hidden' }}>
                        {ROTULO_CONSUMO[consumo]}
                    </Typography>
                </Stack>

            </Stack>
        </ButtonBase >
    )
}
